// accordions js start
function faq_taggol() {
  const accordions = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    const scrollcontent = accordion.getAttribute("js-acc-single-trigger-scroll") || null;
    content.style.maxHeight = 'max-content';
  };
  
  const closeAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    if(content){
      content.style.maxHeight = null;
    }
  };
  
  accordions.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const content = accordion.querySelector("[js-acc-single-content]");
    if(intro){
      intro.onclick = (e) => {
        if (content.style.maxHeight) {
          closeAccordion(accordion);
        } else {
          accordions.forEach((accordion) => closeAccordion(accordion));
          openAccordion(e.target.closest('[js-acc-item]'));
        }
      };
    }
  });   
}

(function() {
  faq_taggol();  
})();

// Menu Hover Start
let items = document.querySelector(".header__inline-menu").querySelectorAll("details") || null;
  if(items){
      items.forEach(item => {
       item.addEventListener("mouseover", () => {
        item.setAttribute("open", true);
         item.querySelector("ul, .megamenu-image-block.mega_menu_2").addEventListener("mouseleave", () => {
           item.removeAttribute("open");
         });
         item.addEventListener("mouseleave", () => {
           item.removeAttribute("open");
         });
       });
      });
  }
// Menu Hover end

/* const faq_main_wap = document.querySelector('[faq_main_wap]') || null;
if (faq_main_wap) {
  const faq_toggles = faq_main_wap.querySelectorAll('[data-act-title]') || null;
  const faq_content_wap = faq_main_wap.querySelector('[faq_content_wap]') || null;
  const faq_content_tabs = faq_content_wap.querySelectorAll('.tabs') || null;
  const faq_dropdown = faq_main_wap.querySelector('.faq-category-dropdown') || null;
  const faq_selected = faq_main_wap.querySelector('.faq-category-selected') || null;
  const mian_tag = document.querySelector('.faq-category')|| null;
  const content = document.querySelector("[js-acc-single-content]");
  
  if (faq_content_wap) {
    if (faq_dropdown) {
      faq_dropdown.addEventListener('click', () => {
        faq_dropdown.classList.toggle('open'); // Add/remove "open" class for the dropdown
      });
    }
  }
} */
//faq section end


// faq scroll and mobile droptab menu
document.addEventListener("DOMContentLoaded", function () {
  const tabButtons = document.querySelectorAll(".faq_section_tab_item");
  const selectedTextElement = document.querySelector(".faq-category-selected");
  const faqCategoryMenu = document.querySelector(".faq-category.mobile-dromenu");

  tabButtons.forEach((button) => {
    button.addEventListener("click", function (e) {
      e.preventDefault();
      
       // Remove 'active' class from faq-category mobile-dromenu
      faqCategoryMenu.classList.remove("active");

      // Update the text inside the 'faq-category-selected' element with the selected tab's name
      const tabName = this.querySelector("a").textContent; // Get the tab name from the link text
      selectedTextElement.textContent = tabName;
      // mobile height spece remove
      if (window.innerWidth <= 768) {
      const accordionContent = document.querySelector("[js-acc-single-content]");
          if (accordionContent) {
            accordionContent.style.maxHeight = "0px";
          }
      }
      // Remove active class from all tab buttons
      tabButtons.forEach((btn) => btn.classList.remove("active-tab"));
      // Add active class to clicked tab button
      this.classList.add("active-tab");

      const targetTitle = this.getAttribute("data-tabs");
      const header = document.querySelector("header"); // or your fixed header selector

      
      // Find the corresponding tab content section
      const targetTab = document.querySelector(`.tabs-content[data-title="${targetTitle}"]`);
      if (targetTab) {
        // Remove active class from all accordions
       // document.querySelectorAll(".accordion").forEach((acc) => acc.classList.remove("active"));

        // Find the first accordion inside the selected tab
        const firstAccordion = targetTab.querySelector(".accordion");

        if (firstAccordion) {
         // firstAccordion.classList.add("active");

          // Ensure the content is visible (open the accordion)
          /* const accordionContent = firstAccordion.querySelector(".accordion__content");
          if (accordionContent) {
            accordionContent.style.maxHeight = accordionContent.scrollHeight + "px";
          } */
          // Smooth scroll to the first accordion
          firstAccordion.scrollIntoView({ behavior: "smooth", block: "start" });

            // Adjust scroll to account for header height
            const headerHeight = header ? header.offsetHeight : 0;

    

     
      console.log(targetTab,headerHeight,"targetTab")
            

              // Get position of the description element
              const targetPosition = targetTab.getBoundingClientRect().top + window.scrollY - headerHeight;
console.log(targetPosition,"targetPosition")
              // Smooth scroll to that position
              window.scrollTo({
                top: targetPosition,
                behavior: "smooth"
              });
        
        }
      }
    });
  });
});

// -----------------Video-------------
document.addEventListener('DOMContentLoaded', function () {
  const playButton = document.getElementById('play-button');
  const volumeButton = document.querySelector('.volume-icon');

  const allVideos = document.querySelectorAll('video');

  if (playButton) {
    playButton.addEventListener('click', function () {
      const videoElement = document.querySelector('video');
      if (videoElement.paused || videoElement.ended) {
        videoElement.play();
        playButton.style.display = 'none';
      } else {
        videoElement.pause();
        playButton.style.display = 'block';
      }
    });
  }

  if (volumeButton) {
    volumeButton.addEventListener('click', function (e) {
      const clickedButton = e.currentTarget;

      // Find closest video to the clicked volume button
      const closestVideo = clickedButton.closest('.video-section__media')?.querySelector('video');

      if (!closestVideo) return;

      // Mute all other videos
      allVideos.forEach(video => {
        if (video !== closestVideo) {
          video.muted = true;
        }
      });

      // Toggle mute on the closest video
      const muteIcon = clickedButton.querySelector('.mute-btn');
      const unmuteIcon = clickedButton.querySelector('.unmute-btn');

      if (closestVideo.muted) {
        closestVideo.muted = false;
        muteIcon?.classList.add("hidden");
        unmuteIcon?.classList.remove("hidden");
      } else {
        closestVideo.muted = true;
        unmuteIcon?.classList.add("hidden");
        muteIcon?.classList.remove("hidden");
      }
    });
  }
});




// -----------------collection page swatch-------------
const radiobtn = document.querySelectorAll('.Product_vairant input');
radiobtn.forEach(radiobtns => {
radiobtns.addEventListener('click', function (event) {
    
  const imgget = this.getAttribute("data-img");
    if (imgget && imgget.trim() !== "") {
      const closestdiv = this.closest('.card-wrapper');
      const addimg = closestdiv.querySelector('img');
      addimg.src = imgget;
      addimg.srcset = imgget;
    }
});
});


// ----------------------product finder page js -------------------



// Select the main "Add All to Cart" button
  function ADDtocart() {
    
  const addToCartButton = document.querySelector('.finder-pro-addtocart');
  
  if (addToCartButton) {
      addToCartButton.addEventListener('click', function () {
          const allProducts = document.querySelectorAll('.finder-product-result'); 
  
          if (allProducts.length === 0) {
              console.error("No products found to add to cart.");
              return;
          }
  
          let cartItems = []; 
  
          allProducts.forEach(product => {
              const idElements = product.querySelectorAll('.Fproduct-variant-id'); 
              const qtyElements = product.querySelectorAll('.quantity-finder'); 
  
              if (idElements.length === 0 || qtyElements.length === 0) {
                  console.warn("Skipping product: Missing variant ID or quantity input.");
                  return;
              }
  
              idElements.forEach((idElement, index) => {
                  const productId = idElement.value;
                  const quantityElement = qtyElements[index]; 
  
                  if (!quantityElement) {
                      console.warn(`No quantity found for product ID: ${productId}`);
                      return;
                  }
  
                  const quantityTotal = parseInt(quantityElement.value) || 1; 
                  if (productId) {
                      cartItems.push({ id: productId, quantity: quantityTotal });
                  }
              });
          });
  
          if (cartItems.length > 0) {
              addToCart(cartItems);
          } else {
              console.error("No valid products found to add.");
          }
      });
  }
  
  // Function to add multiple products to cart
  function addToCart(cartItems) {
      fetch('/cart/add.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest' // Matches product-form headers
          },
          body: JSON.stringify({
              items: cartItems
          })
      })
      .then(response => response.json())
      .then(data => {
          if (data.status) {
              console.error('Error adding to cart:', data);
          } else {
              
                    const this_cartDrawer = document.querySelector('cart-drawer');
                 this_cartDrawer.refresh(true);
          }
      
      })
      .catch(error => {
          console.error('Error adding to cart:', error);
      });
  }
  }

document.addEventListener("DOMContentLoaded", function () {
    const nextButtons = document.querySelectorAll(".next-btn a");
    const backButtons = document.querySelectorAll(".s-back-btn a");
    const steps = document.querySelectorAll(".steps-container");
    const progressBar = document.getElementById("progress");
    let selectedValues = []; // Store selected values
    let currentStep = 0;
    const totalSteps = steps.length;

    function updateProgress() {
        if (progressBar) {
            let progressPercentage = ((currentStep + 1) / totalSteps) * 100;
            progressBar.style.width = progressPercentage + "%";
        }
    }

    nextButtons.forEach((button, index) => {
        button.addEventListener("click", function (event) {
            event.preventDefault();

            if (currentStep < totalSteps - 1) {
                steps[currentStep].style.display = "none";
                currentStep++;
                steps[currentStep].style.display = "flex";
                updateProgress();
            }

            // If this is the last step, generate the URL
            if (currentStep === totalSteps - 1) {
                generateFinalURL();
            }
        });
    });

    backButtons.forEach((button) => {
        button.addEventListener("click", function (event) {
            event.preventDefault();
            if (currentStep > 0) {
                steps[currentStep].style.display = "none";
                currentStep--;
                steps[currentStep].style.display = "flex";
                updateProgress();
            }
        });
    });

    updateProgress();

    // ---------------------- Input Click Event ----------------------
   const inputList = document.querySelectorAll('.input-lists input');

if (inputList) {
    inputList.forEach(function (radio) {
        radio.addEventListener("change", function () {
            const stepdiv = this.closest('.steps-container');
            let nextButton = stepdiv.querySelector(".next-btn a");
          const checkedInputs = stepdiv.querySelectorAll('.input-lists input:checked');

            if (nextButton) {
               if (checkedInputs.length > 0) {
                  nextButton.classList.remove("disabled"); // Enable button if at least one is checked
              } else {
                  nextButton.classList.add("disabled"); // Disable button if none are checked
              }
                
            }

            // Update the selected values array
            selectedValues = Array.from(document.querySelectorAll('.input-lists input:checked'))
                                  .map(input => input.value);

        });
    });
}

function generateFinalURL() {
    const currentUrl = location.origin; // Get full URL path
    const finalUrl = `${currentUrl}/collections/all?view=product-finder&${selectedValues.join("&")}`;
  console.log(selectedValues.join("&"),"kkkkkkkkkkkkkkkkkkkkk")
console.log(finalUrl,'finalUrl')
    fetch(finalUrl)
    .then(response => response.text())  // Get raw HTML
    .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const elements = doc.querySelector('.finder-product-colle'); // Select elements with class "finder-result"
        const finderproduct = document.querySelector('.finder-product-result');

        if (elements) {
            finderproduct.insertAdjacentHTML("beforeend", elements.innerHTML);
            ADDtocart();
        } else {
        // Fix: Move the following line inside `.then()` block
        const spantag = document.querySelector('.found_title');
        if (spantag) {
            spantag.classList.remove("hidden");
        }
        }

    })
    .catch(error => console.error('Fetch Error:', error)); // Fix: Place `.catch()` correctly
}

});



// ------------first button click----- 
const Fbutton = document.querySelector('.button-first a');
if (Fbutton) {
  
Fbutton.addEventListener('click', function(event) {
  event.preventDefault();  
  const bottomdiv = document.querySelector('.step-bottom');
   const topdiv = document.querySelector('.steps-heading');
 
  bottomdiv.style.display = 'block';
  topdiv.style.display = 'none';
});
}

//--------------------------- back button click evnet 
const FbackButton = document.querySelector('.f-back-btn a');
const inputLists = document.querySelectorAll('.input-lists input');
const nextButtons = document.querySelector('.next-btn a');


if (FbackButton) {
    FbackButton.addEventListener('click', function(event) {
        event.preventDefault();  

        // Hide the current step container
        const Fstepdiv = this.closest('.step-bottom');
        if (Fstepdiv) {
            Fstepdiv.style.display = 'none';
        }

        // Show the main heading
        const mainheading = document.querySelector('.steps-heading');
        if (mainheading) {
            mainheading.style.display = 'block';
        }

        // Uncheck all radio buttons inside .input-lists
        inputLists.forEach(input => {
            if (input.type === 'radio' && input.type === 'checkbox') {
                input.checked = false;
                nextButtons.classList.add('disabled');
            }
        });
    });
}


// ---------------custom properties pass product page-------
const keycode = document.querySelector(".key-code-box input");
if (keycode) {
 keycode.addEventListener("keyup", function () {
    const valueGet =  this.value
   document.querySelector('.key-code-value').value = valueGet;
});
}


// --------------- benefits_box close click event------
const benefits_box = document.querySelector(".benefits_box-close");
if (benefits_box) {
  
benefits_box.addEventListener("click", function () {
    const nonediv = document.querySelector('.benefits_box');
    nonediv.style.display = 'none';
});
}


// --------------- video popup------

const videoTag = document.querySelectorAll('.product-video-block .product-video-item');
if (videoTag) {
  
videoTag.forEach(function(item) {

  var videoBlock = item.querySelector('.video-block'); 
  var videoElement = item.querySelector('.video_popup video'); 
    
  var playButton = item.querySelector('.playButton');

  function playVideo() {
    document.querySelectorAll('.product-video-item video').forEach(function(otherVideo) {
      if (otherVideo !== videoElement) {
        otherVideo.pause();
        otherVideo.closest('.product-video-item').querySelector('.playButton').classList.remove('hidden');
      }
    });

    if (videoElement.paused) {
      videoElement.play();
      playButton.classList.add('hidden'); 
      console.log('Video Playing');
    }
  }

  videoBlock.addEventListener('click', function() {
  this.classList.add("mystyle");
        document.querySelector("body").classList.add("video_popup_open");

    if (videoElement.paused) {
      playVideo();
    } else {
      videoElement.pause();
       const videoAll  =  document.querySelectorAll(".video-block")
            videoAll.forEach(function(videoAllRemove) {
              videoAllRemove.classList.remove("mystyle")
            });
      playButton.classList.remove('hidden');
      console.log('Video Paused');
    }
  });
    var videoBlockButton = item.querySelector('.video-btn'); 

   if (videoBlockButton) {
      videoBlockButton.addEventListener('click', function() {
        let currentElement = this; // use `let` to allow reassignment
        const parents = [];
        
        // Traverse the parent nodes
        while (currentElement.parentNode) {
          currentElement = currentElement.parentNode;
          parents.push(currentElement);
        }
        
          const targetParent = parents.find(parent =>
            parent.classList && parent.classList.contains('product-video-item-inner')
        );
       const clickvideo = targetParent.querySelector('.video-block');
        clickvideo.click();
      });
    }
    
  videoElement.addEventListener('ended', function() {
    playButton.classList.remove('hidden');
    console.log('Video Ended');
  });
// --------------- close icocn click 
    var videoClose = item.querySelector('.video_popup'); 
       if (videoClose) {
        videoClose.addEventListener('click', function() {
       const videoAll  =  document.querySelectorAll(".video-block")
            videoAll.forEach(function(videoAllRemove) {
              videoAllRemove.classList.remove("mystyle")
            });
        document.querySelector("body").classList.remove("video_popup_open");
        });
       }
});
}


const qtyButtons = document.querySelectorAll(".qnty-control .button");

if (qtyButtons.length > 0) {
  const qtyAttr = document.querySelector('.product-list-box')?.getAttribute('data-size-qty');
  const hasQtyLimit = !isNaN(parseInt(qtyAttr, 10));
  const qtyplus = hasQtyLimit ? parseInt(qtyAttr, 10) : null;

  function updateTotalCount() {
  let totalCount = 0;
  document.querySelectorAll(".quantity__inputt").forEach(function (input) {
    totalCount += parseInt(input.value) || 0;
  });

  // const addtocart = document.querySelector(".product-form__submit");

  if (hasQtyLimit && qtyplus !== null) {
    document.querySelectorAll(".quantity_plus").forEach(function (button) {
      button.disabled = totalCount >= qtyplus;
    });

  //   if (totalCount >= qtyplus) {
  //     addtocart.disabled = false;
  //   } else {
  //     addtocart.disabled = true;
  //   }
  // } else {
  //   if (totalCount > 0) {
  //     addtocart.disabled = false;
  //   } else {
  //     addtocart.disabled = true;
  //   }

    // "+" button always enabled
    document.querySelectorAll(".quantity_plus").forEach(function (button) {
      button.disabled = false;
    });
  }
}


  qtyButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      const wrapper = this.closest(".qnty-control");
      if (!wrapper) return;

      const input = wrapper.querySelector(".quantity__inputt");
      if (!input) return;

      const currentValue = parseInt(input.value) || 0;
      const change = parseInt(this.getAttribute("data-value")) || 0;

      let totalCount = 0;
      document.querySelectorAll(".quantity__inputt").forEach(function (inp) {
        totalCount += parseInt(inp.value) || 0;
      });

      // ✅ Limit check only if qtyplus is defined
      if (hasQtyLimit && change > 0 && totalCount >= qtyplus) return;

      const newValue = currentValue + change;
      if (newValue >= 0) {
        input.value = newValue;
      }

      updateTotalCount();
    });
  });
}



// =---------------checkbox change event-----------------

// const Einput = document.querySelector('.extra-product-variant-id');
// if (Einput) {
  
// Einput.addEventListener('change', function () {
// const addId = document.querySelector('.Extraproduct-variant-id');
//     if (this.checked) {
//         addId.name = "id"
//         addId.value = this.value; // Pass value when checked
//     } else {
//         addId.name = ""
//         addId.value = ''; // Remove value when unchecked
//     }
// });
// }






  document.addEventListener("DOMContentLoaded", function () {
    const videoSection = document.querySelector('.custom-video');
if (videoSection) {
    const video = videoSection.querySelector('video');
    const playButton = document.getElementById('play-button');
  
    function isInViewport(el) {
      const rect = el.getBoundingClientRect();
      return (
        rect.top < window.innerHeight &&
        rect.bottom > 0
      );
    }

    function checkAndTriggerPlay() {
      if (isInViewport(videoSection)) {
        if (video.paused) {
          playButton.click(); 
        }
      } else {
        if (!video.paused) {
          video.pause();
        }
      }
    }

    window.addEventListener('scroll', checkAndTriggerPlay);
    window.addEventListener('resize', checkAndTriggerPlay);

    checkAndTriggerPlay();
}
  });


// =============================  menu hover JS

document.querySelectorAll('.custom_main_link').forEach(function(element) {
    element.addEventListener('mouseenter', function() {
        var dataTitle = this.getAttribute('link_title');

        // Remove 'active' class from all elements with class '.custom_main_link' and attribute 'data_title'
        document.querySelectorAll('.header_custom_d .custom_main_link[data_title]').forEach(function(link) {
            link.classList.remove('active');
        });

        // Add 'active' class to the hovered element
        this.classList.add('active');

        // Add 'hide' class to all elements with class '.custom_mega-penal' and attribute 'data_title'
        document.querySelectorAll('.custom_mega-penal[link_title]').forEach(function(panel) {
            panel.classList.add('hidden');
        });

       document.querySelectorAll('.col_images_da[link_title]').forEach(function(img) {
            img.classList.add('hidden');
        });

        // Remove 'hide' class from the specific '.custom_mega-penal' that matches the hovered element's 'link_title' value
        if(document.querySelector('.custom_mega-penal[link_title="' + dataTitle + '"]')){ document.querySelector('.custom_mega-penal[link_title="' + dataTitle + '"]').classList.remove('hidden'); }

      if(document.querySelector('.col_images_da[link_title="' + dataTitle + '"]')){ document.querySelector('.col_images_da[link_title="' + dataTitle + '"]').classList.remove('hidden'); }
    });
});


// ====================== new quiz page JS 
// function Appquiz() {
//   const clickdivs = document.querySelectorAll('.featured-promotions-item');

//   if (clickdivs.length) {
//     clickdivs.forEach(div => {
//       div.addEventListener('click', () => {
//         const quizId = div.getAttribute('data-id-quiz');
//         console.log(quizId, 'quizId');

//         if (quizId) {
//           const quizElements = document.querySelectorAll('.quiz-section-wrp .shopify-app-block');

//           quizElements.forEach(el => {
//         const childQuiz = el.querySelector('askwhai-quiz');
//             const quizValue = childQuiz?.getAttribute('quiz');

//             // Hide all fist
//             el.style.opacity = '0';
//             el.style.visibility = 'hidden';
// console.log(quizValue,'quizValue')
//             if (quizValue === quizId) {
//               console.log(quizValue,"quizValue")
//               el.style.opacity = '1';
//               el.style.visibility = 'visible';
//             }
//           });
//         }
//       });
//     });
//   }
// }

// function waitForAskwhaiQuiz() {
//   const interval = setInterval(() => {
//     const quizElements = document.querySelectorAll('.quiz-section-wrp .shopify-app-block');

//     if (quizElements.length > 0) {
//       clearInterval(interval);

//       quizElements.forEach((el, index) => {
//         if (index === 0) {
//           el.style.opacity = '1';
//           el.style.visibility = 'visible';
//         } else {
//           el.style.opacity = '0';
//           el.style.visibility = 'hidden';
//         }
//       });

//       Appquiz();
//     }
//   }, 100);
// }

// waitForAskwhaiQuiz();


// ============custom variant dropdown===========

document.addEventListener('click', function (e) {
  const trigger = e.target.closest('[cus-js-acc-single-trigger]');
  if (!trigger) return; // not a trigger, ignore

  const accItem = trigger.closest('[cus-js-acc-item]');
  const isActive = accItem.classList.contains('active');

  document.querySelectorAll('[cus-js-acc-item]').forEach(item => {
    item.classList.remove('active');
  });

  if (!isActive) {
    accItem.classList.add('active');
  }
});

  if (window.location.pathname === "/pages/quiz-english-full-screen-v2-testing-will-replace-main-english-one-do-not-delete-q2") {
    window.location.href = "https://hexlox.com/pages/produktfinder-quiz-english";
  }
  
const copytext = document.querySelector('.copy-text');
if (copytext) {
  
copytext.addEventListener('click', function () {
    let copyText = document.querySelector('.coupon-code').innerText;

    let tempTextArea = document.createElement("textarea"); 
    tempTextArea.value = copyText;
    document.body.appendChild(tempTextArea);
    tempTextArea.select();
    document.execCommand("copy"); 
    document.body.removeChild(tempTextArea); 
});
}

// ==============coupon bar close=========
const couponbarclose = document.querySelector('.coupon-bar-close');
 if (couponbarclose) {
    const hideUntil = localStorage.getItem('couponBarHideUntil');
    const now = new Date().getTime();

    if (hideUntil && now < parseInt(hideUntil)) {
        document.querySelector('.coupon-bar').style.display = "none";
    }

 
    
    couponbarclose.addEventListener('click', function () {
      console.log("coupon-bar-close")
        document.querySelector('.coupon-bar').style.display = "none";
        const oneDayLater = new Date().getTime() + (24 * 60 * 60 * 1000);
        localStorage.setItem('couponBarHideUntil', oneDayLater.toString());
    });
  }


// ==============dropdown scroll==============

window.addEventListener('DOMContentLoaded', () => {
  const dropdown = document.querySelector('.custom-dropdown');
  if (!dropdown) return;

  const checkedInput = dropdown.querySelector('input[type="radio"]:checked');
  if (!checkedInput) return;

  // Calculate the input's position relative to the dropdown
  const scrollOffset = checkedInput.getBoundingClientRect().top - dropdown.getBoundingClientRect().top;

  dropdown.scrollTop += scrollOffset;

  console.log('Dropdown:', dropdown);
  console.log('Checked Input:', checkedInput);
  console.log('Scroll offset:', scrollOffset);
});
